import axios from "axios";
import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./ForgetPassw0rd.style.css";

const ForgetPassword = () => {
  // دو مرحله: 1) وارد کردن ایمیل و ارسال کد  2) وارد کردن کد + رمز عبور جدید
  const [step, setStep] = useState(1);

  // داده‌های فرم
  const [formData, setFormData] = useState({
    email: "",
    code: "",
    password: "",
    confirmPassword: "",
  });

  // state برای لودینگ و خطاها
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  // کنترل تغییر فیلدهای فرم
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  /**
   * مرحله 1: ارسال کد بازیابی به ایمیل
   */
  const handleSendCode = async () => {
    if (!formData.email.trim()) {
      setErrors((prev) => ({ ...prev, email: "ایمیل را وارد کنید." }));
      return;
    }

    setLoading(true);
    try {
      const data = new FormData();
      data.append("email", formData.email);

      // دریافت توکن از localStorage
      const token = localStorage.getItem("access_token");

      const config = {
        method: "post",
        url: "https://mediumaquamarine-rat-574365.hostingersite.com/api/send-otp-code",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
        data,
      };

      const response = await axios(config);

      if (response.data.is_status) {
        toast.success(response.data.message, {
          className: "toast-message",
          position: "top-center",
        });
        setStep(2);
      } else {
        toast.error(response.data.message, {
          className: "toast-message",
          position: "top-center",
        });
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : "خطایی رخ داده است. لطفاً دوباره تلاش کنید.";
      toast.error(errorMessage, {
        className: "toast-message",
        position: "top-center",
      });
    }
    setLoading(false);
  };

  /**
   * مرحله 2: ارسال کد + رمز عبور جدید به وب سرویس change-password
   */
  const handleResetPassword = async (e) => {
    e.preventDefault();
    let validationErrors = {};

    if (!formData.code.trim()) {
      validationErrors.code = "کد تایید را وارد کنید.";
    }
    if (!formData.password.trim()) {
      validationErrors.password = "رمز عبور را وارد کنید.";
    }
    if (!formData.confirmPassword.trim()) {
      validationErrors.confirmPassword = "تکرار رمز عبور را وارد کنید.";
    }
    if (formData.password !== formData.confirmPassword) {
      validationErrors.confirmPassword = "رمز عبور و تکرار آن مطابقت ندارند.";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setLoading(true);
    try {
      const resetData = new FormData();
      resetData.append("code", formData.code);
      resetData.append("password", formData.password);

      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url: "https://mediumaquamarine-rat-574365.hostingersite.com/api/change-password",
        headers: {
          ...(resetData.getHeaders ? resetData.getHeaders() : {}),
        },
        data: resetData,
      };

      const response = await axios.request(config);

      if (response.data.is_status) {
        toast.success(response.data.message, {
          className: "toast-message",
          position: "top-center",
        });
        // ریدایرکت به صفحه login-register پس از 2 ثانیه
        setTimeout(() => {
          window.location.href = "/login-register";
        }, 2000);
      } else {
        toast.error(response.data.message, {
          className: "toast-message",
          position: "top-center",
        });
      }
    } catch (error) {
      const errorMessage =
        error.response && error.response.data && error.response.data.message
          ? error.response.data.message
          : "خطایی رخ داده است. لطفاً دوباره تلاش کنید.";
      toast.error(errorMessage, {
        className: "toast-message",
        position: "top-center",
      });
    }
    setLoading(false);
  };

  return (
    <div className="login-register-container">
      <ToastContainer autoClose={3000} hideProgressBar={true} />

      <button
        className="back-to-home"
        onClick={() => (window.location.href = "/")}
      >
        ⬅ بازگشت به خانه
      </button>

      <div className="login-register-box">
        <h2 className="forget-password-title">بازیابی رمز عبور</h2>

        {step === 1 && (
          <>
            <h4 className="forget-password-mini-text">
              لطفاً ایمیل خود را وارد کرده و دکمه ارسال کد را بزنید
            </h4>
            <form
              onSubmit={(e) => e.preventDefault()}
              className="form-container"
            >
              <input
                type="email"
                name="email"
                placeholder="ایمیل*"
                value={formData.email}
                onChange={handleChange}
              />
              {errors.email && <p className="error-message">{errors.email}</p>}

              <button
                type="button"
                className="send-code-btn"
                onClick={handleSendCode}
              >
                {loading ? <span className="spinner"></span> : "ارسال کد"}
              </button>
            </form>
          </>
        )}

        {step === 2 && (
          <>
            <form onSubmit={handleResetPassword} className="form-container">
              <input
                type="text"
                name="code"
                placeholder="کد تایید*"
                value={formData.code}
                onChange={handleChange}
              />
              {errors.code && <p className="error-message">{errors.code}</p>}

              <input
                type="password"
                name="password"
                placeholder="رمز عبور جدید*"
                value={formData.password}
                onChange={handleChange}
              />
              {errors.password && (
                <p className="error-message">{errors.password}</p>
              )}

              <input
                type="password"
                name="confirmPassword"
                placeholder="تکرار رمز عبور جدید*"
                value={formData.confirmPassword}
                onChange={handleChange}
              />
              {errors.confirmPassword && (
                <p className="error-message">{errors.confirmPassword}</p>
              )}

              <button type="submit" className="submit-btn">
                {loading ? <span className="spinner"></span> : "تایید"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgetPassword;
